module.exports = __webpack_public_path__ + "static/c14-36d8533ecc02add3e8962ea4e829b142.jpg";